module.exports = __webpack_public_path__ + "assets/img/2多账号.605b0415.jpg";